import { State } from './state.model';

const stateWrapper: {
    state: State | null;
} = {
    state: null,
};

export const currentState = (): State => stateWrapper.state;

export const defaultState = (): void => {
    stateWrapper.state = {
        myFocusHdls: {},
        myFocusPhraseHdls: {},
        caResult: null,
        phase: null,
    };
};
